var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lesson-text-fields"},_vm._l((_vm.textFields),function({ name, label }){return _c('div',{key:name},[(!_vm.filter || _vm.filter[name])?_c('LessonTextField',{attrs:{"label":label,"value":_vm.lesson[name]}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }